import styled from "@emotion/styled";
import { transitionDurationSeconds } from "./tabConstants";

export interface TabUnderlineProps {
    backgroundColor: string;
    leftPx: number;
    widthPlusUnit: string;
    underlineTransition?: boolean;
}

export const TabUnderline = styled("div")<TabUnderlineProps>`
    position: absolute;
    bottom: 0;
    left: ${({ leftPx }) => leftPx}px;
    width: ${({ widthPlusUnit }) => widthPlusUnit};
    height: 2px;
    background-color: ${({ backgroundColor }) => backgroundColor};

    ${({ underlineTransition }) => {
        if (underlineTransition) {
            return `transition: width ${transitionDurationSeconds}s, left ${transitionDurationSeconds}s;`;
        }
    }}
`;
